import Vue, { CreateElement, VNode, VNodeChildren, VNodeData } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { NewRenterBlockStep } from '@/types';
import './step.styl';
import { Link } from '@/components';

@Component({
  name: 'ProfileMemoRulesStep',
})
export default class ProfileMemoRulesStep extends Vue {
  @Prop({type: Object, default: () => {}}) public readonly step!: NewRenterBlockStep;

  public render(createElement: CreateElement): VNode {

    const children: VNodeChildren = [
      createElement('div', { class: 'step-number'}, this.step.number),
      createElement(Link, {
        class: 'step-content p5',
        props: {
          html: this.step.content,
        },
      }),
    ];

    const data: VNodeData = { class: 'step-block'};

    return createElement('div', data, children);
  }
}
